<template src="./Index.html"></template>

<script>
export default {
  components: {},
  created() {
    this.$store.dispatch("lookups/getJobGrades");
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
  },
  computed: {
    jobGrades() {
      return this.$store.state.lookups.jobGrades;
    },
      correlators() {
          return [
          { value: 0, label: "0" },

              { value: 1, label: "1" },
              { value: 2, label: "2" },
              { value: 3, label: "3" },
              { value: 4, label: "4" },
              { value: 5, label: "5" },
              { value: 6, label: "6" },
              { value: 7, label: "7" },
              { value: 8, label: "8" },
              { value: 9, label: "9" },
              { value: 10, label: "10" },

          ]
    
    },     
     months() {
          return [

              { value: 1, label: "1" },
              { value: 2, label: "2" },
              { value: 3, label: "3" },
              { value: 4, label: "4" },
              { value: 5, label: "5" },
              { value: 6, label: "6" },
              { value: 7, label: "7" },
              { value: 8, label: "8" },
              { value: 9, label: "9" },
              { value: 10, label: "10" },
              { value: 11, label: "11" },
              { value: 12, label: "12" },

          ]
    
    },
 
    pageCount() {
      return Math.ceil(
        this.totalItems /
          this.filters.pageSize
      );
    },
  },
  data() {
    return {
       subtitle:"",
      items: [
          {
            text: "التقارير",
        },
        {
          text: "تقرير العلاوات السنوية قبل 90 يوم",
        },       
      ],
      itemId: 0,
      view: 0,
      data: [],
      totalItems: 0,
      filters: {
        page: 1,
        pageSize: 10,
        jobGradeId: null,
        correlatorId: null,
     
      },
      headers: [
        {
          text: "الرقم التسلسلي ",
          value: "employeeNo",
          sortable: false,
          align: "start",
        },
        {
          text: "اسم الموظف",
          value: "fullName",
          sortable: false,
          align: "start",
        },
        { text: "الدرجة الوظيفية الحالية", value: "jobGradeName", sortable: false },     
        { text: "المربوط  الحالي", value: "correlatorId", sortable: false },     
        {
         text: "تاريخ العلاوة القادمة",
         value: "bonusDate",
         sortable: false,
         align: "start",
       },

        // {
        //   text: "الادارة / الفرع",
        //   value: "administration",
        //   sortable: false,
        //   align: "start",
        // },
        // {
        //   text: "القسم ",
        //   value: "department",
        //   sortable: false,
        //   align: "start",
        // },      
        // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "الاجراءات", value: "actions", sortable: false },     
      ],
    };
  },
  methods: {
    changeAdministration() {
      this.filters.departmentId = null;
      this.filters.unitId = null;
      if (this.filters.administrationTypeId != 1002) {
        this.$store.dispatch(
          "lookups/getDepartments",
          this.filters.administrationId
        );
      } else {
        this.$store.dispatch("lookups/getUnitsById", {
          typeId: 1,
          id: this.filters.administrationId,
        });
      }
      this.getAll();
    },
    changeDepartment() {
      this.filters.unitId = null;
      this.$store.dispatch("lookups/getUnitsById", {
        typeId: 2,
        id: this.filters.departmentId,
      });
      this.getAll();
    },
    changeType() {
      this.filters.administrationId = null;
      this.filters.departmentId = null;
      this.filters.unitId = null;
      this.$store.dispatch(
        "lookups/getAdministrationsByType",
        this.filters.administrationTypeId
      );
      this.getAll();
    },    
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("reports/getBonuses", this.filters).then((res)=>{
        this.data = res.data;
        this.totalItems = res.totalItems;
      });
    },
    download() {
      let filters = {
        jobGradeId: this.filters.jobGradeId,
        correlatorId: this.filters.correlatorId,
       
      };
      const paramsString = Object.entries(filters)
        .filter(([, val]) => val !== null)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      window.open(`/api/reports/bonusesExcel?${paramsString}`, "_blank");
    },
    viewPrint(item) {
        // this.$router.push(`/PrintEmploymentStatement/${item.employeeId}`);
      const routeData = this.$router.resolve(`/PrintBonusStatement/${item.employeeId}`);
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
